import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';

export interface StaticPageItem {
  data: {
    id: number;
    enabled: number;
    order: number;
    name: string;
    slug: string;
    title: string;
    content: string;
    effective_date?: string;
    created_at?: string;
    updated_at?: string;
  };
}

export const useGetStaticPage = (pageId: number) => {
  const key = [`STATIC_PAGE_${pageId}`];
  return useQuery(key, async (): Promise<StaticPageItem> => {
    const { data } = await axiosInstance.get(`/api/get-public-static-page/${pageId}`);
    return data;
  });
};
